<iframe [src]="componentStoryUrl$ | async | safeResourceUrl" class="showcase-storybook-iframe" frameborder="0"></iframe>
